module.exports = __webpack_public_path__ + "./assets/web_mobile_display_contact.png";